import { Fragment, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Label,
  Tab,
  TabPane,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Button,
  Icon,
} from "semantic-ui-react";
import { InLocationsItems } from "../../../../../fetch/types/locations.types";
import { runFormater } from "../../../../../shared/utils/runService";
import { MOCK_INFO_CHARGERS } from "../../../../home/homeConstant";
import { InRegularHours } from "../../../../home/sections/components/modal/CPO/modalInformation";
import { daysOfWeek } from "../../../../home/sections/components/modal/CPO/modalSchedule";
import useEnums from "../../../../../shared/hooks/useEnumsData";

export interface InTableChargerColumn {
  name: number;
  basic: Basic[];
  extra: Extra[];
}

export interface Basic {
  key: string;
  oldValue: string;
  newValue: string;
}

export interface Extra {
  key: number;
  items: Item[];
}

export interface Item {
  key: string;
  oldValue: number | string;
  newValue: number | string;
}

interface InTableColumn {
  key: string;
  oldValue: string;
  newValue: string;
  extra?: {
    key: string;
    items: InTableColumn[];
  }[];
}

const generateConnectorFormat = (
  connector: any,
  evse?: InLocationsItems["evses"][0]
) => {
  const oldConnector = evse && evse.connectors.find((item) => item.connector_id === connector.connector_id);
  let basic_connector = [];

  if (connector?.order_number) {
    basic_connector.push({
      key: "Orden Conector",
      oldValue: oldConnector?.order_number || "---",
      newValue: connector.order_number,
    });
  }

  if (connector?.format) {
    basic_connector.push({
      key: "Formato",
      oldValue: oldConnector?.format || "---",
      newValue: connector.format,
    });
  }
  if (connector?.electric_power) {
    basic_connector.push({
      key: "Potencia",
      oldValue: oldConnector?.electric_power || "---",
      newValue: connector.electric_power,
    });
  }
  if (connector?.max_electric_power) {
    basic_connector.push({
      key: "Max. Potencia",
      oldValue: oldConnector?.max_electric_power || "---",
      newValue: connector?.max_electric_power,
    });
  }
  if (connector?.amperage) {
    basic_connector.push({
      key: "Amperaje",
      oldValue: oldConnector?.amperage || "---",
      newValue: connector?.amperage,
    });
  }

  if (connector?.max_amperage) {
    basic_connector.push({
      key: "Amperaje Máximo",
      oldValue: oldConnector?.max_amperage || "---",
      newValue: connector?.max_amperage,
    });
  }

  if (connector?.voltage) {
    basic_connector.push({
      key: "Voltaje",
      oldValue: oldConnector?.voltage || "---",
      newValue: connector?.voltage,
    });
  }

  if (connector?.max_voltage) {
    basic_connector.push({
      key: "Voltaje Máximo",
      oldValue: oldConnector?.max_voltage || "---",
      newValue: connector?.max_voltage,
    });
  }
  if (connector?.standard) {
    basic_connector.push({
      key: "Tipo de conector",
      oldValue: oldConnector?.standard || "---",
      newValue: MOCK_INFO_CHARGERS.standard.filter((x) => x.value === connector?.standard)[0].text,
    });
  }
  return basic_connector;
};

const generateChargerStructure = (
  charger: InLocationsItems["evses"][0],
  oldEvses?: InLocationsItems["evses"][0]
) => {
  let basic_charger = [];

  if (charger?.order_number) {
    basic_charger.push({
      key: "Orden Cargador",
      oldValue: oldEvses?.order_number.toString() || "---",
      newValue: charger?.order_number.toString(),
    });
  }
  if (charger?.floor_level) {
    basic_charger.push({
      key: "Nivel",
      oldValue: oldEvses?.floor_level?.toString() || "---",
      newValue: charger?.floor_level.toString(),
    });
  }
  if (charger?.physical_reference && charger?.physical_reference === '') {
    basic_charger.push({
      key: "Referencia Física",
      oldValue: oldEvses?.physical_reference.toString() || "---",
      newValue: charger?.physical_reference.toString(),
    });
  }
  if (charger?.coordinates?.latitude) {
    basic_charger.push({
      key: "Ubicación (Latitud)",
      oldValue: oldEvses?.coordinates?.latitude.toString() || "---",
      newValue: charger.coordinates?.latitude.toString() || "---",
    });
  }

  if (charger?.coordinates?.longitude) {
    basic_charger.push({
      key: "Ubicación (Longitud)",
      oldValue: oldEvses?.coordinates?.longitude.toString() || "---",
      newValue: charger.coordinates?.longitude.toString() || "---",
    });
  }

  if (charger?.model) {
    basic_charger.push({
      key: "Modelo",
      oldValue: oldEvses?.model || "---",
      newValue: charger?.model,
    });
  }
  if (charger?.brand) {
    basic_charger.push({
      key: "Marca",
      oldValue: oldEvses?.brand || "---",
      newValue: charger?.brand,
    });
  }
  if (charger?.max_electric_power) {
    basic_charger.push({
      key: "Max. Potencia",
      oldValue: oldEvses?.max_electric_power.toString() || "---",
      newValue: charger?.max_electric_power.toString(),
    });
  }
  if (charger?.uso_exclusivo) {
    basic_charger.push({
      key: "Dominio Privado",
      oldValue: oldEvses?.uso_exclusivo ? "SI" : "NO",
      newValue: charger?.uso_exclusivo ? "SI" : "NO",
    });
  }
  if (charger?.activation_capabilities) {
    basic_charger.push({
      key: "Capacidades de Activación",
      oldValue:
        oldEvses?.activation_capabilities &&
        oldEvses?.activation_capabilities.length > 0
          ? oldEvses?.activation_capabilities.join(",")
          : "No establecido",
      newValue:
        charger?.activation_capabilities.length > 0
          ? charger?.activation_capabilities.join(",")
          : "---",
    });
  }
  if (charger?.payment_capabilities) {
    basic_charger.push({
      key: "Capacidades de Pago",
      oldValue:
        oldEvses?.payment_capabilities &&
        oldEvses?.payment_capabilities.length > 0
          ? oldEvses?.payment_capabilities.join(", ")
          : "No establecido",
      newValue:
        charger?.payment_capabilities.length > 0
          ? charger?.payment_capabilities.join(", ")
          : "---",
    });
  }

  if (charger?.uso_exclusivo) {
    basic_charger.push({
      key: "Dominio Privado",
      oldValue: oldEvses?.uso_exclusivo ? "SI" : "NO",
      newValue: charger?.uso_exclusivo ? "SI" : "NO",
    });
  }

  if (!charger?.connectors || charger.connectors.length < 1)
    return { basic: basic_charger, connector: [] };

  const connector = charger.connectors.map((item) => {
    return {
      key: item.connector_id,
      items: generateConnectorFormat(item, oldEvses),
    };
  });

  return { basic: basic_charger, connector };
};

const ConfirmT6Content: React.FC<{ info: any; electricalData?: any; onDownload?: any }> = ({ info, electricalData, onDownload }) => {
  const [infoGeneral, setInfoGeneral] = useState<InTableColumn[]>([]);
  const [infoChargers, setInfoChargers] = useState<InTableChargerColumn[]>([]);
  
  // Cargar empresas distribuidoras para el lookup de nombres
  const { enums: distributionCompanies } = useEnums("distribution_companies");

  useEffect(() => {
    if (!info?.fieldsRequest) return;
    generateTableStructure();
    // eslint-disable-next-line
  }, []);

  const generateTableStructure = () => {
    try {

      let general: any = [];

      const valueToMap= info.status==="APROBADO" && info.lastFieldsRequest ?  info.lastFieldsRequest  : info.fieldsRequest;

      if (valueToMap?.name) {
        general.push({
          key: "Nombre",
          oldValue: info.location?.name,
          newValue: valueToMap.name,
        });
      }
      if (valueToMap?.order_number) {
        general.push({
          key: "Orden Cargador",
          oldValue: info.location?.order_number,
          newValue: valueToMap.order_number,
        });
      }
      if (valueToMap?.twentyfourseven !== undefined) {
        general.push({
          key: "Atención 24 horas",
          oldValue: info.location?.twentyfourseven ? 'Si':'No',
          newValue: valueToMap.twentyfourseven ? 'Si':'No',
        });
      }
      if (valueToMap?.parking_type) {
        general.push({
          key: "Tipo Estacionamiento",
          oldValue: info.location?.parking_type,
          newValue: valueToMap.parking_type,
        });
      }
      if (valueToMap?.time_zone) {
        general.push({
          key: "Zona Horaria",
          oldValue: info.location?.time_zone,
          newValue: valueToMap.time_zone,
        });
      }
      if (valueToMap?.support_phone_number) {
        general.push({
          key: "Número de Soporte",
          oldValue: info.location?.support_phone_number,
          newValue: valueToMap.support_phone_number,
        });
      }
      if (valueToMap?.directions && valueToMap?.directions === '') {
        general.push({
          key: "Indicaciones",
          oldValue: info.location?.directions,
          newValue: valueToMap.directions,
        });
      }
      if (valueToMap?.charging_when_closed !== undefined) {
        general.push({
          key: "Acceso con sucursal cerrada",
          oldValue: info.location?.charging_when_closed ? "Si" : "No",
          newValue: valueToMap.charging_when_closed ? "Si" : "No",
        });
      }
      if (valueToMap?.address) {
        general.push({
          key: "Dirección",
          oldValue: info.location?.address,
          newValue: valueToMap.address,
        });
      }
      if (valueToMap?.coordinates?.latitude) {
        general.push({
          key: "Ubicación (Latitud)",
          oldValue: info.location?.coordinates?.latitude,
          newValue: valueToMap.coordinates?.latitude,
        });
      }
      if (valueToMap?.coordinates?.longitude) {
        general.push({
          key: "Ubicación (Longitud)",
          oldValue: info.location?.coordinates?.longitude,
          newValue: valueToMap.coordinates?.longitude,
        });
      }
      setInfoGeneral(general);
      // Charger Info Structure
      if (valueToMap?.evses && valueToMap.evses.length > 0) {
        const itemIterator = valueToMap.evses.filter(
          (item: any) => item
        );
        let evses: InLocationsItems["evses"] = itemIterator;

        const charger = evses.map((item) => {
          const oldEvses = info?.location?.evses.find(
            (element: any) => String(element.evse_uid) === String(item.evse_uid)
          );
          const formatEvses = generateChargerStructure(item, oldEvses);
          return {
            name: item.evse_uid,
            basic: formatEvses.basic,
            extra: formatEvses.connector,
          };
        });

        setInfoChargers(charger);
      }
    } catch (error) {
      toast.error("Ocurrio un error al obtener la estructura");
    }
  };
  const getRenderTable = () => {
    const newArray: InRegularHours[] = [];
    if (!info.fieldsRequest?.opening_times?.regular_hours)
      return (
        <Label basic className="text-center">
          No se han realizado cambios en esta sección.
        </Label>
      );

    info.fieldsRequest.opening_times.regular_hours.forEach((hours: any) => {
      const existingDay = newArray.find(
        (item: any) => item.weekday === hours.weekday
      );

      if (existingDay) {
        existingDay.hours.push({
          period_begin: hours.period_begin,
          period_end: hours.period_end,
        });
      } else {
        newArray.push({
          weekday: hours.weekday,
          hours: [
            {
              period_begin: hours.period_begin,
              period_end: hours.period_end,
            },
          ],
        });
      }
    });

    const rows = newArray.map((item) => (
      <Table.Row key={item.weekday}>
        <Table.Cell>{daysOfWeek[item.weekday - 1]}</Table.Cell>
        <Table.Cell>
          {item.hours.map((hour, index) => (
            <div key={index}>
              {hour.period_begin} - {hour.period_end}
            </div>
          ))}
        </Table.Cell>
      </Table.Row>
    ));

    return (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Día de la semana</Table.HeaderCell>
            <Table.HeaderCell>Horas de trabajo</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{rows}</Table.Body>
      </Table>
    );
  };

  const getChargers = () => {
    if (infoChargers.length < 1) return [];
    return infoChargers.map((item) => {
      return {
        menuItem: `Cargador ${item.name}`,
        render: () => (
          <TabPane
            className="px-0"
            style={{
              border: "none",
              maxHeight: "450px",
              overflowY: "auto",
            }}
          >
            <Table definition>
              <TableHeader>
                <TableRow>
                  <TableHeaderCell />
                  <TableHeaderCell>Valores actuales</TableHeaderCell>
                  <TableHeaderCell>{info.status==="APROBADO" ? "Valores anteriores" : "Nuevos valores"}</TableHeaderCell>
                  </TableRow>
              </TableHeader>
              <TableBody
                style={{
                  maxHeight: "500px",
                  overflow: "hidden",
                  overflowy: "auto",
                }}
              >
                {item.basic.map((basic) => (
                  <TableRow>
                    <TableCell>{basic.key}.</TableCell>
                    <TableCell>{basic.oldValue}</TableCell>
                    <TableCell>{basic.newValue}</TableCell>
                  </TableRow>
                ))}

                {item.extra.map((extra) => (
                  <Fragment>
                    <TableRow>
                      <TableCell colSpan="3" className="text-center">
                        Conector {extra.key}
                      </TableCell>
                    </TableRow>
                    {extra.items.map((item) => (
                      <TableRow>
                        <TableCell>{item.key}.</TableCell>
                        <TableCell>{item.oldValue}</TableCell>
                        <TableCell>{item.newValue}</TableCell>
                      </TableRow>
                    ))}
                  </Fragment>
                ))}
              </TableBody>
            </Table>
          </TabPane>
        ),
      };
    });
  };

  const getElectricalPane = () => {
    console.log("getElectricalPane - electricalData:", electricalData);
    console.log("getElectricalPane - info.location:", info?.location);
    
    if (!electricalData) {
      console.log("getElectricalPane - NO electricalData, retornando null");
      return null;
    }

    // Verificar si realmente hay campos eléctricos en los datos
    const hasElectricalFields = 
      electricalData.connected_to_electrical_grid !== undefined ||
      electricalData.connection_date !== undefined ||
      electricalData.client_number !== undefined ||
      electricalData.requires_extension !== undefined ||
      electricalData.feasibility_info !== undefined ||
      electricalData.tentative_connection_date !== undefined ||
      electricalData.dx_company_id !== undefined ||
      electricalData.feasibility_document_key !== undefined;

    console.log("getElectricalPane - hasElectricalFields:", hasElectricalFields);

    if (!hasElectricalFields) {
      console.log("getElectricalPane - No hay campos eléctricos en electricalData, retornando null");
      return null;
    }

    const formatBoolean = (value: any) => {
      if (value === true) return "Sí";
      if (value === false) return "No";
      return "No especificado";
    };

    const formatValue = (value: any) => {
      if (value === undefined || value === null || value === "") return "---";
      return value;
    };

    // Obtener valores actuales del location
    const currentLocation = info.location || {};
    
    // Determinar si hay datos eléctricos previos
    const hasExistingData = currentLocation.connected_to_electrical_grid !== undefined && 
                            currentLocation.connected_to_electrical_grid !== null;

    const electricalRows: Array<{ key: string; oldValue: string; newValue: string }> = [];

    // Estado de Conexión
    if (electricalData.connected_to_electrical_grid !== undefined) {
      electricalRows.push({
        key: "Estado de Conexión",
        oldValue: hasExistingData ? formatBoolean(currentLocation.connected_to_electrical_grid) : "---",
        newValue: formatBoolean(electricalData.connected_to_electrical_grid),
      });
    }

    const isConnectedNew = electricalData.connected_to_electrical_grid === true;
    const isConnectedOld = currentLocation.connected_to_electrical_grid === true;

    // Fecha de Conexión (cuando está conectado)
    if (electricalData.connection_date !== undefined || currentLocation.connection_date) {
      electricalRows.push({
        key: "Fecha de Conexión",
        oldValue: formatValue(currentLocation.connection_date),
        newValue: formatValue(electricalData.connection_date),
      });
    }

    // Número de Cliente (cuando está conectado)
    if (electricalData.client_number !== undefined || currentLocation.client_number) {
      electricalRows.push({
        key: "Número de Cliente",
        oldValue: formatValue(currentLocation.client_number),
        newValue: formatValue(electricalData.client_number),
      });
    }

    // ¿Requiere Ampliación? (cuando NO está conectado)
    if (electricalData.requires_extension !== undefined || currentLocation.requires_extension !== undefined) {
      electricalRows.push({
        key: "¿Requiere Ampliación?",
        oldValue: hasExistingData && !isConnectedOld ? formatBoolean(currentLocation.requires_extension) : "---",
        newValue: !isConnectedNew ? formatBoolean(electricalData.requires_extension) : "---",
      });
    }

    // Información de Factibilidad (cuando NO está conectado)
    if (electricalData.feasibility_info !== undefined || currentLocation.feasibility_info) {
      electricalRows.push({
        key: "Información de Factibilidad",
        oldValue: formatValue(currentLocation.feasibility_info),
        newValue: formatValue(electricalData.feasibility_info),
      });
    }

    // Fecha Tentativa de Conexión (cuando NO está conectado)
    if (electricalData.tentative_connection_date !== undefined || currentLocation.tentative_connection_date) {
      electricalRows.push({
        key: "Fecha Tentativa de Conexión",
        oldValue: formatValue(currentLocation.tentative_connection_date),
        newValue: formatValue(electricalData.tentative_connection_date),
      });
    }

    // Empresa Distribuidora (Dx) - Buscar el nombre en la lista de enums
    if (electricalData.dx_company_id !== undefined || currentLocation.dx_company_id) {
      // Función helper para obtener el nombre de la empresa por ID
      const getCompanyName = (companyId: number | undefined) => {
        if (!companyId) return "---";
        const company = distributionCompanies.find((c: any) => c.id === companyId);
        return company ? company.name : `ID: ${companyId}`;
      };

      const oldCompanyName = currentLocation.dx_company || getCompanyName(currentLocation.dx_company_id);
      const newCompanyName = electricalData.dx_company_id 
        ? getCompanyName(electricalData.dx_company_id)
        : "---";

      electricalRows.push({
        key: "Empresa Distribuidora (Dx)",
        oldValue: formatValue(oldCompanyName),
        newValue: newCompanyName,
      });
    }

    // Documento de Factibilidad - No incluir en la tabla principal
    // Se manejará por separado como botón de descarga

    const handleDownloadDocument = async (documentKey: string, isOld: boolean = false) => {
      if (!onDownload) {
        toast.error("Función de descarga no disponible");
        return;
      }

      try {
        const locationId = info.location?.location_id;
        if (!locationId) {
          toast.error("No se pudo obtener el ID de la ubicación");
          return;
        }

        const result: any = await onDownload("documents", locationId);
        const urls = result?.urls || [];
        const keys = result?.keys || [];

        if (urls.length > 0 && keys.length > 0) {
          const docIndex = keys.findIndex((key: string) => key === documentKey);
          if (docIndex !== -1 && urls[docIndex]) {
            window.open(urls[docIndex], "_blank");
          } else {
            toast.error("No se encontró el documento solicitado");
          }
        } else {
          toast.error("No se encontraron documentos disponibles");
        }
      } catch (error) {
        console.error("Error descargando documento:", error);
        toast.error("Error al descargar el documento");
      }
    };

    const hasNewDocument = electricalData.feasibility_document_key;
    const hasOldDocument = currentLocation.feasibility_document_key;

    return {
      menuItem: "Conexión Eléctrica",
      render: () => (
        <TabPane attached="top">
          <Table definition>
            <TableHeader>
              <TableRow>
                <TableHeaderCell>Campo</TableHeaderCell>
                <TableHeaderCell>Valores actuales</TableHeaderCell>
                <TableHeaderCell>{info.status === "APROBADO" ? "Valores anteriores" : "Nuevos valores"}</TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {electricalRows.map((row) => (
                <TableRow key={row.key}>
                  <TableCell>{row.key}</TableCell>
                  <TableCell>{row.oldValue}</TableCell>
                  <TableCell>{row.newValue}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {/* Sección de documentos de factibilidad */}
          {(hasNewDocument || hasOldDocument) && (
            <div style={{ marginTop: "20px", padding: "10px", backgroundColor: "#f8f9fa", borderRadius: "5px" }}>
              <Label size="large" style={{ marginBottom: "10px" }}>
                <Icon name="file pdf" />
                Documentos de Factibilidad
              </Label>
              <div style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "wrap" }}>
                {hasOldDocument && (
                  <Button
                    primary
                    icon
                    labelPosition="left"
                    onClick={() => handleDownloadDocument(currentLocation.feasibility_document_key, true)}
                  >
                    <Icon name="download" />
                    Descargar Documento Actual
                  </Button>
                )}
                {hasNewDocument && (
                  <Button
                    color="green"
                    icon
                    labelPosition="left"
                    onClick={() => handleDownloadDocument(electricalData.feasibility_document_key, false)}
                  >
                    <Icon name="download" />
                    Descargar Documento Nuevo
                  </Button>
                )}
              </div>
            </div>
          )}
        </TabPane>
      ),
    };
  };

  const panes = [
    {
      menuItem: "Información General",
      render: () => (
        <TabPane attached="top">
          <Table definition>
            <TableHeader>
              <TableRow>
                <TableHeaderCell />
                <TableHeaderCell>Valores actuales</TableHeaderCell>
                <TableHeaderCell>{info.status==="APROBADO" ? "Valores anteriores" : "Nuevos valores"}</TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {infoGeneral.length ? (
                infoGeneral.map(({ key, newValue, oldValue }) => (
                  <Table.Row key={key}>
                    <Table.Cell>{key}</Table.Cell>
                    <Table.Cell>{oldValue}</Table.Cell>
                    <Table.Cell>{newValue}</Table.Cell>
                  </Table.Row>
                ))
              ) : (
                <Table.Row key={Date.now()}>
                  <Table.Cell colSpan={3} className="text-center">
                    No se han realizado cambios en esta sección.
                  </Table.Cell>
                </Table.Row>
              )}
            </TableBody>
          </Table>
        </TabPane>
      ),
    },
    {
      menuItem: "Cargadores",
      render: () => (
        <TabPane attached="top">
          {infoChargers.length < 1 ? (
            <Label basic>No se han realizado cambios en esta sección.</Label>
          ) : (
            <Tab panes={getChargers()} />
          )}
        </TabPane>
      ),
    },
    {
      menuItem: "Información Horario",
      render: () => getRenderTable(),
    },
  ];

  // Agregar pane eléctrico si hay datos eléctricos
  console.log("Verificando si agregar pane eléctrico - electricalData:", electricalData);
  if (electricalData) {
    console.log("Hay electricalData, llamando a getElectricalPane()");
    const electricalPane = getElectricalPane();
    console.log("electricalPane obtenido:", electricalPane);
    if (electricalPane) {
      console.log("Agregando electricalPane a panes");
      panes.push(electricalPane);
    } else {
      console.log("electricalPane es null, no se agrega");
    }
  } else {
    console.log("No hay electricalData, no se agrega pane eléctrico");
  }
  
  console.log("Panes finales:", panes.map(p => p.menuItem));

  return (
    <Fragment>
      <Label basic style={{ lineHeight: "18px" }}>
        {`El usuario ${info?.user?.name} (${runFormater(
          info?.user?.rut
        )} ), ha solicitado ${
          electricalData && (!infoGeneral.length && !infoChargers.length)
            ? 'cambios de conexión a la red eléctrica'
            : 'los siguientes cambios'
        } para el folio ${info.folio}`}
      </Label>
      <Tab panes={panes} />
    </Fragment>
  );
};
export default ConfirmT6Content;
